import axios from './axios';
import recaptcha from "./recaptcha";
import webrtc from './webrtc'

export default {
  axios,
  recaptcha,
  webrtc
}